<template>
    <div class="d-flex flex-column w-100 chamado">
        <div class="nav">
            <img src="../../assets/logo.png" alt="logo">
        </div>
        <div class="d-flex flex-lg-row flex-column gap-sm h-100">
            <span class="ml-3 mt-3">
                <strong>Status:</strong>
                <div class="d-flex gap-sm align-items-center">
                    <font-awesome-icon :icon="['fas', 'circle']" :class="selecionaCorOnline()" />
                    <span v-if="io.status">Online</span>
                    <span v-else>Offline</span>
                </div>
            </span>
            <div class="d-flex flex-column chamadoAtual p-5">
                <div class="d-flex flex-column w-100 gap-md" v-if="ultimoChamado != undefined">
                    <div class="d-flex w-100 gap-xll justify-content-center">
                        <div class="d-flex flex-column">
                        <span class="grey">Nome</span>
                        <h1>
                            {{ ultimoChamado.funcionario }}
                        </h1>
                    </div>
                    <div class="d-flex flex-column">
                        <span class="grey">Horário</span>
                        <h1>
                        {{ ultimoChamado.horario }}
                        </h1>
                    </div>
                    </div>
                    <div class="d-flex border-default justify-content-center">
                        <div class="d-flex flex-column bg-green p-5 w-50">
                            <h5 class="white">Atendimento</h5>
                            <h3>
                                {{ ultimoChamado.exame.exame  }}
                            </h3>
                        </div>
                        <div class="d-flex flex-column p-5 w-50">
                            <h5 class="grey-2">Sala</h5>
                            <h3>
                                {{ ultimoChamado.exame.salaExame  }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex chamadosPassados p-5">
                <div class="d-flex w-100 gap-lg justify-content-start" v-for="(a, index) in chamadosFormatados" :key="index">
                    <div class="d-flex flex-column" style="border-bottom: 1px solid grey;">
                        <h2>
                            {{ a.funcionario }}
                        </h2>
                        <h2 class="grey-2" style="font-size: 30px !important;">{{ a.exame.exame + " - " + a.exame.salaExame }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SocketService from "../../service/SocketService.js";


export default {
	name: "Chamado",
 		data() {
		return {
			io: new SocketService(),
			chamados: [],
		};
	},
	created() {
		this.io.conectar(1);
		this.io.chamar(this.chamados);
		this.io.isOnline();
		this.io.handleError();
	},
	mounted() {
		window.addEventListener("beforeunload", event => this.showWarning(event));
	},
	beforeDestroy() {
		this.io.desconectar(1);
		window.removeEventListener("beforeunload", event => this.showWarning(event));
	},
	methods: {
		showWarning(event) {
			event.returnValue = "";
			event.returnValue = "Tem certeza de que deseja sair desta página? Você irá perder todos os dados de chamados realizados";
		},
		selecionaCorOnline() {
			if (this.io.status) {
				return "verde";
			} else {
				return "vermelho";
			}
		},
	},
	computed: {
		chamadosFormatados() {
			const arrCopia = JSON.parse(JSON.stringify(this.chamados));
			return arrCopia.reverse();
		},
		ultimoChamado() {
			return this.chamados[this.chamados.length - 1] == undefined ? undefined : this.chamados[this.chamados.length - 1];
		},
	},
};
</script>

<style scoped>
.grey-2{
    color: grey;
}
h5{
    font-size: 40px;
}
h3{
    font-size: 35px;
}
.white{
    color: white;
}
.border-default{
    border: 1px solid rgb(151, 151, 151);
}
.verde{
    color: green;
}
.vermelho{
    color: red;
}
h1{
    font-size: 80px;
}
h2{
    font-size: 45px;
}
.chamado{
    background-color: rgb(255, 255, 255) !important;
    height: 100vh;
}
.nav{
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 75px;
    background-color: #172026;
}
.nav > img{
    width: 250px;
}
.chamadoAtual{
    width: 55%;
    min-height: 100%;
    justify-content: center;
    align-items: center;
}
.chamadoPassado{
    width: 100%;
}
.chamadosPassados{
    background-color: rgb(207, 207, 207);
    width: 45%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: space-around;
}
.grey{
    color: grey;
    font-size: 20px;
}
@media screen and (max-width:1200px){
    .chamadosPassados, .chamadoAtual{
        width: 100% !important;
    }
}
.bg-green{
    background-color: #2bd6a5;
}
</style>




// WEBPACK FOOTER //
// src/views/agendamento/Chamado.vue